import type { TFunction } from "i18next";
import type { SelectMenuLabels } from "@majourneys/ui";

/**
 * The strings every house dropdown needs, in one place.
 *
 * `@majourneys/ui` holds no copy on purpose — the package is shared with the
 * city sites, which do not run our locale files — so each `SelectMenu` has to
 * be handed nine strings. Written out at every call site, six of the nine are
 * the same six keys, and the seventh drifts: one menu says "Search", the next
 * "Search…", and the Arabic build gets whichever the last author remembered.
 *
 * Only `title` changes per menu, so only `title` is an argument. The six shared
 * keys live under `common.menu_*` in all seven locale files.
 */
export function menuLabels(t: TFunction, title: string): SelectMenuLabels {
  return {
    title,
    searchPlaceholder: t("common.menu_search"),
    clearSearch: t("common.menu_clear_search"),
    closeList: t("common.menu_close_list"),
    emptyTitle: t("common.menu_empty"),
    noMatchTitle: () => t("common.menu_no_match"),
    noMatchHint: t("common.menu_no_match_hint"),
  };
}
